import axios from 'axios';

const create = async function workersServiceCreate (data) {
  const response = await axios.post(
    '/api/worker/',
    data,
  );

  return response.data.data;
};

const getList = async function workersServiceGetList () {
  const response = await axios.get('/api/worker');

  return response.data.data;
};

const getById = async function workersServiceGetById (id) {
  const response = await axios.get(`/api/worker/${encodeURIComponent(id)}`);

  return response.data.data;
};

const remove = async function workersServiceRemove (id) {
  const response = await axios.delete(
    `/api/worker/${encodeURIComponent(id)}`,
  );

  return response.data.data;
};

const update = async function workersServiceUpdate (id, data) {
  const response = await axios.put(
    `/api/worker/${encodeURIComponent(id)}`,
    data,
  );

  return response.data.data;
};

const setVacation = async function workersServiceSetVacation ({
  worker,
  dateStart,
  dateEnd,
}) {
  const response = await axios.post(
    `/api/worker/vacation/${encodeURIComponent(worker)}`,
    { dateStart, dateEnd },
  );

  return response.data.data;
};

const getDepartmentOptions = async function workersServiceGetDepartments () {
  const response = await axios.get('/api/department');

  return response.data.data.map(({ id, name }) => ({
    value: id,
    text: name,
  }));
};

export default {
  create,
  getList,
  getById,
  remove,
  update,
  setVacation,
  getDepartmentOptions,
};
